import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-pill.css';

var getClassNameList = classNames.bind(styles);
var UitkTriggerPill = function (props) {
    var _a;
    var active = props.active, children = props.children, className = props.className, disabled = props.disabled, icon = props.icon, id = props.id, name = props.name, onClick = props.onClick, selected = props.selected, toggleState = props.toggleState, domRef = props.domRef;
    var baseClassName = 'uitk-pill';
    var buttonClassName = getClassNameList("".concat(baseClassName, " ").concat(baseClassName, "-content"), className, (_a = {},
        _a["".concat(baseClassName, "-trigger-toggle-state")] = toggleState,
        _a["".concat(baseClassName, "-active")] = active,
        _a["".concat(baseClassName, "-disabled")] = disabled,
        _a["".concat(baseClassName, "-selected")] = selected,
        _a));
    return (React.createElement("button", { id: id, name: name, type: "button", onClick: onClick, disabled: disabled, className: buttonClassName, "aria-expanded": toggleState, ref: domRef },
        icon && React.createElement(UitkIcon, { className: getClassNameList("".concat(baseClassName, "-icon")), name: icon }),
        React.createElement("span", { className: getClassNameList("".concat(baseClassName, "-text")) }, children),
        React.createElement(UitkIcon, { name: "expand_more", className: getClassNameList("".concat(baseClassName, "-trigger-icon")) })));
};
UitkTriggerPill.displayName = 'UitkTriggerPill';

export { UitkTriggerPill };
